import {
  getPbPageServerSideProps,
  PageBuilderDesktop,
} from 'modules/page-builder';

export const getServerSideProps: GetServerSideProps = ((context) =>
  getPbPageServerSideProps(
    context,
    context.query.slug as string,
  )) as GetServerSideProps;

export default PageBuilderDesktop;
